import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { MeProvider, useMe } from "@/context/MeContext";
import AppShell from "@/components/AppShell";
import { Loading, ErrorBox } from "@/components/common";
import { NotEnrolled, SignInPage, SignUpPage, Welcome } from "@/pages/AuthPages";
import Home from "@/pages/Home";
import Diario from "@/pages/Diario";
import Orario from "@/pages/Orario";
import Verifiche from "@/pages/Verifiche";
import Bacheca from "@/pages/Bacheca";
import Messaggi from "@/pages/Messaggi";
import Altro from "@/pages/Altro";
import Calendario from "@/pages/Calendario";
import Portali from "@/pages/Portali";
import GestioneClasse from "@/pages/GestioneClasse";

function Gate() {
  const { loading, error, reload, isAdmin } = useMe();
  if (loading) return <div className="min-h-[100dvh] pt-24"><Loading /></div>;
  if (error === "not_enrolled") return <NotEnrolled />;
  if (error) return <div className="p-6"><ErrorBox text="Impossibile caricare il profilo." onRetry={reload} /></div>;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/diario" element={<Diario />} />
        <Route path="/orario" element={<Orario />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/portali" element={<Portali />} />
        <Route path="/verifiche" element={<Verifiche />} />
        <Route path="/bacheca" element={<Bacheca />} />
        <Route path="/messaggi" element={<Messaggi />} />
        <Route path="/altro" element={<Altro />} />
        <Route path="/classe" element={isAdmin ? <GestioneClasse /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

const Root = () => (
  <>
    <Show when="signed-in"><MeProvider><Gate /></MeProvider></Show>
    <Show when="signed-out"><Welcome /></Show>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="/*" element={<Root />} />
        </Routes>
      </ClerkAuthProvider>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
